/* sk-pdp-faq.js — Filter-Chips + Suche über FAQ und Kundenfragen (sections/sk-pdp-faq.liquid), 30.10.2026.
   Formular „Frage stellen“ und „Alle N Fragen anzeigen“ bleiben in assets/sk-product-questions.js. */
(function () {
  function init(root) {
    if (root.__skPdpFaq) return;
    root.__skPdpFaq = 1;
    var chips = root.querySelectorAll('[data-faq-tab]');
    var search = root.querySelector('[data-pdpfaq-search]');
    var none = root.querySelector('[data-pdpfaq-none]');
    var faqBlock = root.querySelector('[data-pdpfaq-block="faq"]');
    var pqBlock = root.querySelector('[data-pdpfaq-block="kundenfragen"]');
    var cat = 'all';
    var faqItems = function () { return root.querySelectorAll('.product-faq-item'); };
    var pqItems = function () { return root.querySelectorAll('[data-pq-item]'); };
    function expandPq() {
      var t = root.querySelector('template[data-pq-extra-tpl]');
      if (t && t.parentNode) t.parentNode.replaceChild(t.content, t);
    }
    function apply() {
      var term = search ? search.value.trim().toLowerCase() : '';
      var shown = 0;
      if (term) expandPq();
      faqItems().forEach(function (el) {
        var ok = (cat === 'all' || el.getAttribute('data-faq-cat') === cat) && (!term || el.textContent.toLowerCase().indexOf(term) !== -1);
        el.hidden = !ok; if (ok) shown++;
        if (!ok) el.removeAttribute('open');
      });
      var pqOn = cat === 'all' || cat === 'kundenfragen';
      var more = root.querySelector('[data-pq-more]');
      pqItems().forEach(function (el) {
        var ok = pqOn && (term ? el.textContent.toLowerCase().indexOf(term) !== -1 : !el.hasAttribute('data-pq-extra'));
        el.hidden = !ok; if (ok) shown++;
      });
      if (more) more.hidden = !!term || !pqOn || !root.querySelector('[data-pq-extra]');
      if (faqBlock) faqBlock.hidden = cat === 'kundenfragen';
      var sub = root.querySelector('.sk-pdpfaq__subhead');
      if (sub) sub.hidden = !pqOn;
      if (none) none.hidden = shown > 0 || !(term || cat !== 'all');
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        cat = c.getAttribute('data-faq-tab');
        chips.forEach(function (x) { var on = x === c; x.classList.toggle('product-faq__tab--active', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        apply();
      });
    });
    if (search) search.addEventListener('input', apply);
    /* Akkordeon: immer nur eine FAQ offen (wie bisher) */
    root.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!(d instanceof HTMLDetailsElement) || !d.open || !d.classList.contains('product-faq-item')) return;
      faqItems().forEach(function (x) { if (x !== d) x.removeAttribute('open'); });
    }, true);
  }
  function run() { document.querySelectorAll('[data-sk-pdpfaq]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
